// extracted by mini-css-extract-plugin
export default {"line":"charge_line__CNo7x","text":"charge_text__Teesa","pointText":"charge_pointText__RyLn7","pointWrapper":"charge_pointWrapper__2yt7R"};